import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from 'notistack';
import { GridApiPro } from "@mui/x-data-grid-pro/models/gridApiPro";
import { GridRowId } from "@mui/x-data-grid";
import ServiceKeys from "../../../services/serviceKeys";
import * as providersService from '../../../services/providersService';
import { ServerError } from "../../../types/Error";
import { queryClient } from "../../../config/localStorage";
import { Provider } from "../../../types/Providers";

const useCreateProviderMutation = (apiRef?: React.MutableRefObject<GridApiPro>) => {
    const { enqueueSnackbar } = useSnackbar();

    return useMutation({
        mutationFn: async ({ providerName, provider }: { providerName: string, provider: Provider}) => {
            await providersService.createProvider(providerName, provider);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries([ServiceKeys.Providers, variables.providerName]);
            // Delete the old row in MUI as the ID may not reflect the existing one in the BE
            if (apiRef) apiRef.current.updateRows([{ id: variables.provider.id, _action: 'delete' }]);
            enqueueSnackbar(`Provider ${variables.providerName} record created`, { variant: 'success' });
        },
        onError: (err: ServerError, variables) => {
            // Set the row to edit mode again if it fails to create the provider record
            if (apiRef) apiRef.current.startRowEditMode({ id: variables.provider.id as GridRowId });
            enqueueSnackbar(`Failed to create provider ${variables.providerName} record. ${err.response.data.log}`, { variant: 'error' });
        }
    });
}

export default useCreateProviderMutation;